var map = {
	"./FamilyMart/shoplogo.png": "4f55",
	"./Laz/Lazlogo.png": "42fb",
	"./Laz/logo.png": "34e1",
	"./SM-wholesale shop/shoplogo.png": "03bc",
	"./Shop2u/logo.png": "14f7",
	"./TikTok-Wholesale/shoplogo.png": "0c20",
	"./TikTok/TikToklogo.png": "a861",
	"./TikTok/logo.png": "9d1e",
	"./TikTok/shoplogo.png": "6738"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "5439";